export class NumberUtils {
  static formatUSD(amount: number) {
    const formattedAmount = Math.abs(amount).toFixed(2);
    return amount < 0 ? `-$${ formattedAmount }` : `$${ formattedAmount }`;
  }
}
